var _g, _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _rect3, _rect4, _path7, _rect5, _rect6, _path8, _rect7, _rect8, _path9, _rect9, _rect10, _circle, _path10, _path11, _path12, _path13, _rect11, _rect12, _path14, _circle2, _circle3, _circle4, _rect13, _rect14, _path15, _rect15, _rect16, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 379,
    height: 319,
    viewBox: "0 0 379 319",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 92.7842,
    y: 71.8789,
    width: 177.432,
    height: 174.305,
    rx: 87.1526,
    stroke: "#3B86FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 69.335,
    y: 46.8662,
    width: 224.33,
    height: 224.33,
    rx: 112.165,
    stroke: "#3B86FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 48.2314,
    y: 25.7627,
    width: 266.538,
    height: 266.538,
    rx: 133.269,
    stroke: "#3B86FF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 24,
    y: 0.75,
    width: 315,
    height: 316.563,
    rx: 157.5,
    stroke: "#3B86FF",
    strokeWidth: 1.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 252.597,
    y: 82.0996,
    width: 48.7456,
    height: 48.7456,
    rx: 9.59911,
    fill: "#F8FAFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 252.597,
    y: 82.0996,
    width: 48.7456,
    height: 48.7456,
    rx: 9.59911,
    stroke: "#D7DFED",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.045 111.396L281.894 111.396",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272.045 115.09L281.894 115.09",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M272.045 97.8535L281.894 97.8535",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M272.045 101.547L281.894 101.547",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M283.125 95.3926V101.548C283.125 104.268 280.92 106.473 278.2 106.473H275.738C273.018 106.473 270.814 108.678 270.814 111.397V117.553",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M270.812 95.3926V101.548C270.812 104.268 273.017 106.473 275.737 106.473H278.199C280.919 106.473 283.124 108.678 283.124 111.397V117.553",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 83.6475,
    width: 30.1679,
    height: 30.1679,
    rx: 5.88358,
    fill: "#F8FAFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 83.6475,
    width: 30.1679,
    height: 30.1679,
    rx: 5.88358,
    stroke: "#D7DFED",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5924 104.602V104.724C20.5924 105.307 20.1199 105.78 19.5369 105.78H9.22543C8.64249 105.78 8.16992 105.307 8.16992 104.724V98.1035C8.16992 97.5203 8.64249 97.0475 9.22543 97.0475H10.1997M20.5924 104.602L22.5401 95.8313C22.7642 95.0524 22.1799 94.2758 21.3698 94.2758H18.6438M20.5924 104.602V99.3066C20.5924 98.7543 20.1447 98.3066 19.5924 98.3066H18.6438M10.1997 97.0475H11.7112C11.9911 97.0475 12.2596 97.1587 12.4575 97.3568L13.0977 97.9973C13.2957 98.1953 13.5641 98.3066 13.8441 98.3066H18.6438M10.1997 97.0475V91.6863C10.1997 91.5068 10.3451 91.3613 10.5245 91.3613H18.319C18.4984 91.3613 18.6438 91.5068 18.6438 91.6863V92.2955V98.3066",
    stroke: "#102039",
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44238,
    y: 213.691,
    width: 30.1679,
    height: 30.1679,
    rx: 5.88358,
    fill: "#F8FAFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.44238,
    y: 213.691,
    width: 30.1679,
    height: 30.1679,
    rx: 5.88358,
    stroke: "#D7DFED",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7649 226.351H26.9793M17.2144 221.613V222.849M25.3772 221.613V222.849M27.7803 225.012V233.869C27.7803 235.063 26.8239 236.032 25.6442 236.032H17.0999C15.9202 236.032 14.9639 235.063 14.9639 233.869V225.012C14.9639 223.817 15.9202 222.849 17.0999 222.849H25.6442C26.8239 222.849 27.7803 223.817 27.7803 225.012Z",
    stroke: "#102039",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 339.292,
    y: 195.113,
    width: 33.2642,
    height: 33.2642,
    rx: 6.50283,
    fill: "#F8FAFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 339.292,
    y: 195.113,
    width: 33.2642,
    height: 33.2642,
    rx: 6.50283,
    stroke: "#D7DFED",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M355.975 213.912L355.483 214.478C355.765 214.723 356.185 214.723 356.467 214.478L355.975 213.912ZM351.418 214.538C351.816 214.425 352.047 214.011 351.934 213.612C351.821 213.214 351.406 212.982 351.008 213.095L351.213 213.817L351.418 214.538ZM360.942 213.095C360.544 212.982 360.129 213.214 360.016 213.612C359.903 214.011 360.134 214.425 360.532 214.538L360.737 213.817L360.942 213.095ZM360.208 207.47H359.458C359.458 207.982 359.257 208.601 358.887 209.284C358.523 209.958 358.027 210.634 357.516 211.245C357.008 211.853 356.497 212.381 356.112 212.757C355.92 212.945 355.761 213.094 355.65 213.195C355.595 213.246 355.552 213.285 355.524 213.31C355.509 213.323 355.499 213.332 355.492 213.338C355.488 213.341 355.486 213.343 355.484 213.345C355.484 213.345 355.483 213.346 355.483 213.346C355.483 213.346 355.483 213.346 355.483 213.346C355.483 213.346 355.483 213.346 355.483 213.346C355.483 213.346 355.483 213.346 355.975 213.912C356.467 214.478 356.467 214.478 356.467 214.478C356.467 214.478 356.468 214.477 356.468 214.477C356.468 214.477 356.468 214.477 356.469 214.476C356.47 214.476 356.471 214.475 356.472 214.474C356.474 214.471 356.478 214.468 356.483 214.464C356.492 214.456 356.505 214.445 356.522 214.43C356.555 214.4 356.603 214.357 356.664 214.301C356.785 214.19 356.956 214.03 357.161 213.83C357.57 213.43 358.117 212.865 358.667 212.207C359.214 211.553 359.777 210.791 360.206 209.998C360.63 209.215 360.958 208.339 360.958 207.47H360.208ZM355.975 213.912C356.467 213.346 356.467 213.346 356.467 213.346C356.467 213.346 356.467 213.346 356.467 213.346C356.467 213.346 356.467 213.346 356.467 213.346C356.467 213.346 356.466 213.345 356.466 213.345C356.464 213.343 356.462 213.341 356.458 213.338C356.452 213.332 356.441 213.323 356.427 213.31C356.398 213.285 356.355 213.246 356.3 213.195C356.189 213.094 356.03 212.945 355.838 212.757C355.453 212.381 354.943 211.853 354.434 211.245C353.923 210.634 353.427 209.958 353.063 209.284C352.693 208.601 352.492 207.982 352.492 207.47H351.742H350.992C350.992 208.339 351.32 209.215 351.744 209.998C352.173 210.791 352.736 211.553 353.283 212.207C353.833 212.865 354.38 213.43 354.789 213.83C354.994 214.03 355.165 214.19 355.286 214.301C355.347 214.357 355.395 214.4 355.428 214.43C355.445 214.445 355.458 214.456 355.467 214.464C355.472 214.468 355.476 214.471 355.478 214.474C355.479 214.475 355.481 214.476 355.481 214.476C355.482 214.477 355.482 214.477 355.482 214.477C355.482 214.477 355.483 214.478 355.483 214.478C355.483 214.478 355.483 214.478 355.975 213.912ZM351.742 207.47H352.492C352.492 205.613 354.036 204.079 355.975 204.079V203.329V202.579C353.239 202.579 350.992 204.753 350.992 207.47H351.742ZM355.975 203.329V204.079C357.914 204.079 359.458 205.613 359.458 207.47H360.208H360.958C360.958 204.753 358.712 202.579 355.975 202.579V203.329ZM364.441 216.734H363.691C363.691 216.96 363.585 217.243 363.25 217.573C362.912 217.905 362.385 218.239 361.673 218.536C360.253 219.128 358.239 219.512 355.975 219.512V220.262V221.012C358.387 221.012 360.606 220.606 362.25 219.921C363.07 219.579 363.783 219.153 364.302 218.641C364.824 218.127 365.191 217.482 365.191 216.734H364.441ZM355.975 220.262V219.512C353.711 219.512 351.697 219.128 350.277 218.536C349.565 218.239 349.038 217.905 348.7 217.573C348.365 217.243 348.259 216.96 348.259 216.734H347.509H346.759C346.759 217.482 347.126 218.127 347.648 218.641C348.167 219.153 348.88 219.579 349.7 219.921C351.344 220.606 353.563 221.012 355.975 221.012V220.262ZM347.509 216.734H348.259C348.259 216.455 348.427 216.079 348.98 215.653C349.526 215.232 350.355 214.84 351.418 214.538L351.213 213.817L351.008 213.095C349.835 213.429 348.812 213.889 348.064 214.465C347.325 215.035 346.759 215.8 346.759 216.734H347.509ZM360.737 213.817L360.532 214.538C361.596 214.84 362.424 215.232 362.97 215.653C363.523 216.079 363.691 216.455 363.691 216.734H364.441H365.191C365.191 215.8 364.625 215.035 363.886 214.465C363.138 213.889 362.115 213.429 360.942 213.095L360.737 213.817Z",
    fill: "#102039"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 103.976,
    y: 55.7812,
    width: 36.3604,
    height: 36.3604,
    rx: 7.12209,
    fill: "#F8FAFF"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 103.976,
    y: 55.7812,
    width: 36.3604,
    height: 36.3604,
    rx: 7.12209,
    stroke: "#D7DFED",
    strokeWidth: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 122.432,
    cy: 74.0165,
    r: 8.66496,
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 69.2021L118.58 75.9416",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.58 69.2021H120.506C121.569 69.2021 122.431 70.0642 122.431 71.1277C122.431 72.1911 121.569 73.0532 120.506 73.0532H118.58",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M121.469 73.0537L126.283 78.8303",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M121.468 78.8303L126.282 73.0537",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 348.581,
    y: 96.0322,
    width: 30.1679,
    height: 30.1679,
    rx: 5.88358,
    fill: "#F8FAFF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 348.581,
    y: 96.0322,
    width: 30.1679,
    height: 30.1679,
    rx: 5.88358,
    stroke: "#D7DFED",
    strokeWidth: 0.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M361.959 105.378L362.084 105.461C363.042 106.1 364.29 106.1 365.247 105.461L365.373 105.378C365.759 105.12 366.214 104.982 366.679 104.982C367.979 104.982 369.033 106.036 369.033 107.336V108.235C369.033 109.098 368.69 109.925 368.08 110.535L367.948 110.667C367.657 110.958 367.471 111.338 367.42 111.746L366.83 116.473C366.774 116.917 366.397 117.25 365.95 117.25C365.517 117.25 365.147 116.936 365.076 116.509L364.558 113.406C364.486 112.969 364.108 112.649 363.666 112.649C363.223 112.649 362.846 112.969 362.773 113.406L362.256 116.509C362.185 116.936 361.815 117.25 361.381 117.25C360.934 117.25 360.557 116.917 360.502 116.473L359.911 111.746C359.86 111.338 359.674 110.958 359.383 110.667L359.252 110.535C358.642 109.925 358.299 109.098 358.299 108.235V107.336C358.299 106.036 359.353 104.982 360.653 104.982C361.118 104.982 361.572 105.12 361.959 105.378Z",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 363.666,
    cy: 109.583,
    r: 0.766697,
    fill: "#102039"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 361.365,
    cy: 108.05,
    r: 0.766697,
    fill: "#102039"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 365.966,
    cy: 108.05,
    r: 0.766697,
    fill: "#102039"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5605,
    y: 170.343,
    width: 36.3604,
    height: 36.3604,
    rx: 7.12209,
    fill: "#F8FAFF"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 74.5605,
    y: 170.343,
    width: 36.3604,
    height: 36.3604,
    rx: 7.12209,
    stroke: "#D7DFED",
    strokeWidth: 0.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85 180.531V185.434C85 189.853 88.5817 193.434 93 193.434C97.4183 193.434 101 189.853 101 185.434V184.144C97.134 184.144 94 187.278 94 191.144V196.531V189.531C94 184.561 89.9706 180.531 85 180.531Z",
    stroke: "#102039",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 143.25,
    y: 110.781,
    width: 81.5,
    height: 81.5,
    rx: 18.75,
    fill: "#F8FAFF"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 143.25,
    y: 110.781,
    width: 81.5,
    height: 81.5,
    rx: 18.75,
    stroke: "#D7DFED",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M193.168 168.031H174.835C173.862 168.031 172.93 167.645 172.242 166.957C171.554 166.27 171.168 165.337 171.168 164.365V138.698C171.168 137.725 171.554 136.793 172.242 136.105C172.93 135.418 173.862 135.031 174.835 135.031H187.668L196.835 144.198V164.365C196.835 165.337 196.448 166.27 195.761 166.957C195.073 167.645 194.14 168.031 193.168 168.031Z",
    fill: "#065EEA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M187.668 135.031V142.365C187.668 142.851 187.861 143.317 188.205 143.661C188.549 144.005 189.015 144.198 189.501 144.198H196.835",
    fill: "#C0D6F9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M177.125 149.468H186.75",
    stroke: "#C0D6F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M177.125 154.281H186.75",
    stroke: "#C0D6F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M177.125 159.094H186.75",
    stroke: "#C0D6F9",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no_results.324e35359036a4524fc0a143eaf1220d.svg";
export { ForwardRef as ReactComponent };